module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0012.b940e7e8.jpg";